<div class="d-flex justify-content-center">
  @if (type=='compromise-reports') {
    <iframe class="d-flex" width="80%" height="90%" [src]='env.urlDatastudioCompro | safe' frameborder="0" style="border:0" allowfullscreen></iframe>
  }
  @if (type=='attestations') {
    <iframe class="d-flex" width="80%" height="90%" [src]="env.urlDatastudioAttestation | safe" frameborder="0" style="border:0" allowfullscreen></iframe>
  }
</div>

